<template>
  <div class="youtube-video" :style="{width:width}">
    <span class="mdi mdi-close close" @click="closeFn"></span>
    <div :id="playerId"></div>
  </div>
</template>
<script setup>
 import YouTubePlayer from "youtube-player"
 const props = defineProps({
  youTubeId: { type: String, required: true  },
  width: { type: String, default: '100%' },
})
const emit = defineEmits(['closeFn'])
const playerId = computed(()=>{
  let str = Math.random().toString(36).substring(2, 9)
  return `youtube-player-${str}`
})
const player = ref('')
onMounted(() => {
  initPlayer();
  loadPlayer();
});
onBeforeUnmount(() => {
  player.value && player.value.destroy();
});
watch(
  () => props.youTubeId,
  () => loadPlayer()
);
const initPlayer = () => {
  try {
    player.value = YouTubePlayer(playerId.value, {
      width: '100%',
      height: '100%',
      videoId:props.youTubeId,
      autoplay:1,
      playsinline: 1,
      enablejsapi:1,
      modestbranding:1,
      loop:1
    });
  } catch (error) {
    console.log(error);
  }
};
const loadPlayer = () => {
  try {
    player.value.loadVideoById(props.youTubeId);
  } catch (error) {
    console.log(error);
  }
};
const play = () => {
  if(player.value){
    player.value.seekTo(1); 
    player.value.playVideo()
  }
};
const seekTo = (seconds)=> { player.value.seekTo(seconds)}
const stopVideo = ()=> { player.value.stopVideo()}
const closeFn = ()=>{
  stopVideo()
  emit('closeFn')
}
defineExpose({ play,seekTo,stopVideo })
</script>
<style lang="scss" scoped>
.youtube-video{
  padding-top: 23px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  background: #000;
  .close{
    font-size: 24px;
    position: absolute;
    top: 0px;
    right: 2px;
    color: #fff;
    cursor: pointer;
  }
 
}

</style> 